// key identifies file name for image and is used in every href
// value 
export const value=["Associate Professor and Head","Ph.D. Student","M.S. Student","M.Tech. Student","B.Tech. Student","Collaborator"] 

export const faculty_members=[
  {
    pub:'yes',
    key: 'sridhar',
    value: 0,
    designation: 'Associate Professor and Head',
    email:'ch@iittp.ac.in',
    title: 'Sridhar Chimalakonda',
    desc: 'Software Engineering',
    links:`
    LinkedIn [https://www.linkedin.com/in/sridharch]
    Google Scholar [https://scholar.google.com/citations?user=X3AR0HgAAAAJ&hl=en]
    Github [https://github.com/SridharChimalakonda]
    Twitter [https://twitter.com/ChimalakondaSri]
    ORCiD [https://orcid.org/0000-0003-0818-8178]
    ` 
  },
  {
    pub:'yes',
    key: 'varsha',
    value: 0,
    designation: 'Assistant Professor',
    email:'varshabhat@iittp.ac.in',
    title: 'Varsha Bhat K',
    desc: 'Cryptography',
    links:`
    LinkedIn []
    Google Scholar []
    Github []
    Twitter []
    ORCiD []
    ` 
  },
]

export const members = [
  {
    pub: 'yes',
    key: 'venkat',
    value: 4,
    email: 'cs22b058@iittp.ac.in',
    title: 'Venkat Koushal',
    desc: 'Exploring',
    links: `
    Github [] 
    LinkedIn []
    `
  },
  {
    pub: 'yes',
    key: 'raghavendra',
    value: 4,
    email: 'cs23b026@iittp.ac.in',
    title: 'Raghavendra Pappu',
    desc: 'Exploring',
    links: `
    Github [] 
    LinkedIn []
    `
  },
  {
    pub: 'yes',
    key: 'upendra',
    value: 2,
    email: 'cs25s513@iittp.ac.in',
    title: 'K Upendra',
    desc: 'Hello WOrLD.',
    links: `
    Github [https://github.com/Upendra2003] 
    LinkedIn []
    `
  },
  {
    pub: 'yes',
    key: 'nandini',
    value: 1,
    email: 'CS25D506@iittp.ac.in',
    title: 'Meka Naga Nandini Devi',
    desc: '',
    links: `
    Github [] 
    LinkedIn []
    `
  },
  {
    pub: 'yes',
    key: 'stany',
    value: 4,
    email: 'cs23b059@iittp.ac.in',
    title: 'Koppala Stanycletus',
    desc: 'HCI',
    links: `
    Github [https://github.com/Stany-Cletus] 
    LinkedIn [https://www.linkedin.com/in/koppala-stanycletus-7540b6272/]
    `
  },
  {
    pub: 'yes',
    key: 'sarang',
    value: 4,
    email: 'cs24b039@iittp.ac.in',
    title: 'Sarang Mittal',
    desc: '',
    links: `
    Github [https://github.com/sm2909] 
    LinkedIn []
    `
  },
  {
    pub: 'yes',
    key: 'sharat',
    value: 2,
    email: 'cs26s003@iittp.ac.in',
    title: 'Sharat Jacob Jacob',
    desc: 'Privacy Preserving across Applications',
    links: `
    Github [https://github.com/Sharatjacob2] 
    LinkedIn [https://www.linkedin.com/in/sharat-jacob-jacob/]
    Personal Website [https://twicenamed.netlify.app/]
    `
  },
  {
    pub: 'yes',
    key: 'srikrishna',
    value: 4,
    email: 'cs23b058@iittp.ac.in',
    title: 'Kidambi Venkata Srikrishna',
    desc: 'COBOL(Legacy systems), Compliance checking',
    links: `
    Github [https://github.com/SrikrishnaKidambi] 
    LinkedIn [https://www.linkedin.com/in/venkata-srikrishna-kidambi-6b45bb287/]
    `
  },
  {
    pub: 'yes',
    key: 'kavya',
    value: 3,
    email: 'cs24m111@iittp.ac.in',
    title: 'G Kavyasri',
    desc: 'SE for AI',
    links: `
    Github [https://github.com/cs24m111] 
    LinkedIn [https://www.linkedin.com/in/kavyasri-gajula-511624249/]
    `
  },
  {
    pub: 'yes',
    key: 'pranav',
    value: 2,
    email: 'cs25s523@iittp.ac.in',
    title: 'V Pranav',
    desc: 'Trustworthy in AI Agents',
    links: `
    Github [https://share.google/xuyU3y1gPuDFToO7G] 
    LinkedIn [https://www.linkedin.com/in/pranav-v-353337298?utm_source=share_via&utm_content=profile&utm_medium=member_android]
    `
  },
  {
    pub: 'yes',
    key: 'shivadharshan',
    value: 4,
    email: 'cs22b057@iittp.ac.in',
    title: 'Shivadharshan S',
    desc: '',
    links: `
    Github [https://github.com/Shiva9361] 
    `
  },
  {
    pub: 'yes',
    key: 'kowshik',
    value: 4,
    email: 'cs22b015@iittp.ac.in',
    title: 'KOWSHIK REDDY CHALLA ',
    desc: '',
    links: ` 
    `
  },
  {
    pub: 'yes',
    key: 'aarya',
    value: 4,
    email: 'cs22b018@iittp.ac.in',
    title: 'Aarya Chepuri',
    desc: '',
    links: ` 
    `
  },
  {
    pub: 'yes',
    key: 'sanjay',
    value: 4,
    email: 'cs22b029@iittp.ac.in',
    title: 'K Sanjay Varshith ',
    desc: '',
    links: `
    LinkedIn [https://www.linkedin.com/in/sanjay-varshith?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app]  
    Github [https://github.com/Sanjayvarshith] 
    `
  },
  {
    pub: 'yes',
    key: 'mokshith',
    value: 4,
    email: 'cs22b046@iittp.ac.in',
    title: 'Tanguturi Mokshith Reddy ',
    desc: '',
    links: `
    LinkedIn [https://www.linkedin.com/in/mokshith-tanguturi-aa7455293/]  
    Github [https://github.com/Mokshith1708] 
    `
  },
  {
    pub: 'yes',
    key: 'sasaank',
    value: 4,
    email: 'cs22b059@iittp.ac.in',
    title: 'Sasaank Janapati ',
    desc: '',
    links: `
    LinkedIn [https://www.linkedin.com/in/sasaank-janapati-25056b29a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app]  
    Github [https://github.com/SasaankJanapati] 
    `
  },
  {
    pub: 'yes',
    key: 'akilesh',
    value: 4,
    email: 'cs22b040@iittp.ac.in',
    title: 'Akilesh P',
    desc: '',
    links: `
    Github [https://github.com/Akileshdash] 
    `
  },
  {
    pub: 'yes',
    key: 'sonith',
    value: 4,
    email: 'cs22b036@iittp.ac.in',
    title: 'M V Sonith',
    desc: '',
    links: `
    LinkedIn [https://www.linkedin.com/in/sonith-m-v-0a7a4b256?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app]  
    Github [https://github.com/sonith17] 
    `
  },
  {
    pub: 'yes',
    key: 'hemasri',
    value: 4,
    email: 'cs20b020@iittp.ac.in',
    title: 'Hemasri Sai Lella ',
    desc: 'Energy aware software engineering ',
    links: `
    LinkedIn [https://www.linkedin.com/in/hemasri-sai-lella-bba10b227]  
    Github [https://github.com/LellaHemasriSai] 
    `
  },
  {
    pub: 'yes',
    key: 'preethi',
    value: 4,
    email: 'cs20b030@iittp.ac.in',
    title: 'Preethi Varsha Marivina ',
    desc: 'User Interface Energy',
    links: `
    LinkedIn [https://www.linkedin.com/in/preethi-varsha-marivina?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app]  
    Github [https://github.com/PreethiVarshaM] 
    `
  },
  {
    pub: 'yes',
    key: 'manasa',
    value: 4,
    email: 'cs20b019@iittp.ac.in',
    title: 'Kurra Manasa',
    desc: 'Energy Domain',
    links: ` 
    `
  },
  {
    pub: 'yes',
    key: 'siddhartha',
    value: 4,
    email: 'cs20b040@iittp.ac.in',
    title: 'Siddhartha G',
    desc: '',
    links: `
    LinkedIn [https://www.linkedin.com/in/siddharthag22/]  
    Github [https://github.com/S1ddh4rthaG] 
    `
  },
  {
    pub: 'yes',
    key: 'rahul',
    value: 3,
    email: 'cs22m110@iittp.ac.in',
    title: 'Rahul Krishna Gaddam ',
    desc: 'AI4SE and SE4AI',
    links: `
    LinkedIn [https://www.linkedin.com/in/rahul-krishna-gaddam-912254168]  
    Github [https://github.com/RahulKrishna8029] 
    `
  },
  {
    pub: 'yes',
    key: 'ajinkya',
    value: 2,
    email: 'cs23s501@iittp.ac.in',
    title: 'Ajinkya Sawarkar',
    desc: '',
    links: `
    LinkedIn [https://www.linkedin.com/in/ajinkya-sawarkar-99ab921bb?trk=universal-search-cluster]  
    `
    }   
].sort((a,b) => a.value-b.value);


export const alumini = [
  {
    key: 'jaimin',
    value: 4,
    email: 'cs22b051@iittp.ac.in',
    title: 'Viramgama Jaimin ',
    desc: '',
    links: `
    LinkedIn [https://www.linkedin.com/in/jaimin-viramgama-802387253]   
    Github [https://github.com/i-apex] 
    `
  },
  {
    key: 'kranthi',
    value: 4,
    email:'cs19b036@iittp.ac.in',
    title: 'Sedamaki Kranthi',
    desc: 'Software Engineering, ML, AI for SE',
    links:`
    LinkedIn [https://in.linkedin.com/in/kranthisedamaki]
    `
  },
  {
    key: 'chaitanya',
    value: 2,
    email:'cs18s502@iittp.ac.in',
    title: 'Chaitanya S. Lakkundi',
    desc: '',
    links:'' 
  },
  {
    key: 'anuraag',
    value: 4,
    email:'cs19b012@iittp.ac.in',
    title: 'Anuraag Reddy',
    desc: 'Code Summarization',
    links:`
    LinkedIn [https://in.linkedin.com/in/anuraag-reddy-6181b814b]
    `
  },
  {
    key: 'aashrith',
    value: 4,
    email:'cs19b025@iittp.ac.in',
    title: 'Madasu Aashirth Sai',
    desc: 'Code Summarization',
    links:`
    LinkedIn [https://in.linkedin.com/in/aashrith-sai-madasu-170771217]
    `
  },
  {
    key: 'jahnavi',
    value: 2,
    email:'cs22s504@iittp.ac.in',
    title: 'Jahnavi K',
    desc: 'Software Engineering, ML, AI for SE',
    links:`
    `
  },
  {
    key: 'rajrupa',
    value: 2,
    email:'cs22s504@iittp.ac.in',
    title: 'Rajrupa Chattaraj',
    desc: 'Software Engineering, ML, AI for SE',
    links:`
    LinkedIn [https://in.linkedin.com/in/rajrupa-chattaraj-5936ba157]
    `
  },
    {
    key: 'eashan',
    value: 1,
    email:'cs21d002@iittp.ac.in',
    title: 'A Eashaan Rao',
    desc: 'Cross-Project Learning',
    links:`
    LinkedIn [https://www.linkedin.com/in/a-eashaan-rao-786977110]
    Github [https://github.com/Eashurox]
    Twitter [https://twitter.com/eashaan_a]
    Research Gate [https://www.researchgate.net/profile/Eashaan-Rao]
    ` 
  },
    {
    key: 'akhila',
    value: 1,
    email:'cs19d504@iittp.ac.in',
    title: 'Akhila Sri Manasa Venigalla',
    desc: 'Software Documentation',
    links:`
    LinkedIn [https://www.linkedin.com/in/akhila-sri-manasa7896]
    Google Scholar [https://scholar.google.com/citations?user=--HXC1wAAAAJ&hl=en]
    Github [https://github.com/AkhilaSriManasa]
    Twitter [https://twitter.com/AkhilaSriManasa]
    ResearchGate [https://www.researchgate.net/profile/Akhila-Sri-Manasa-Venigalla]
    ORCiD [https://orcid.org/0000-0003-4356-0334]
    ` 
  },
  {
    key: 'sureshjain',
    value: 5,
    email:'sureshjain@iittp.ac.in',
    title: 'Suresh Jain',
    desc: 'Civil and Environmental Engineering',
    links:`
      Website [https://sureshjain-com.webnode.com/]
     ` 
  },
  {
    key: 'akash',
    value: 4,
    email:'tee15b007@iittp.ac.in',
    title: 'Akash Dhasade',
    desc: '↠ Software Engineer (iManage) ↠ PhD (ETH, Zurich)', 
    links:''
  },
  {
    key: 'saket',
    value: 4,
    email:'tce15b020@iittp.ac.in',
    title: 'Saket Dattatreya Joshi', 
    desc: '', 
    links:''
  },
  {
    pub:'yes',
    key: 'dheeraj',
    value: 4,
    email:'cs17b028@iittp.ac.in',
    title: 'Dheeraj Vagavolu',
    desc: '↠ Masters at University of Waterloo, Canada',
    links:`
    LinkedIn [https://www.linkedin.com/in/v-dheeraj-98a2b9166]
    Github [https://github.com/dheerajrox]

    ` 
  },
  {
    pub: 'no',
    key: 'kowndinya',
    value: 4,
    email:'cs17b032@iittp.ac.in',
    title: 'Kowndinya Boyalakuntla',
    desc: '',
    links:'' 
  },
  {
    pub: 'no',
    key: 'karthik',
    value: 4,
    email:'cs17b026@iittp.ac.in',
    title: 'Karthik Chandra',
    desc: '',
    links:'' 
  },
  {
    pub:'yes',
    key: 'rishitha',
    value: 4,
    email:'cs17b014@iittp.ac.in',
    title: 'K Rishitha ',
    desc: '↠ Software developer at UBS, Pune',
    links:`
    LinkedIn [https://www.linkedin.com/in/rishitha-kalicheti-0176a0179]
    Google Scholar [https://scholar.google.com/citations?user=JUUB4ekAAAAJ&hl=en]
    Github [https://github.com/rishitha957]
    Research Gate [https://www.researchgate.net/profile/Rishitha-Kalicheti]
    `, 
  },
  {
    pub:'yes',
    key: 'aparna',
    value: 4,
    email:'cs17b005@iittp.ac.in',
    title: 'Aparna Vadlamani',
    desc: '↠ SDE at Reliance Jio',
    links:`
    LinkedIn [https://www.linkedin.com/in/aparna-vadlamani-315227192]
    Github [https://github.com/aparnavadlamani]
    Twitter [https://twitter.com/aparna25v]
    ResearchGate [https://www.researchgate.net/profile/Aparna-Vadlamani]
    ` 
  },
  {
    pub: 'no',
    key: 'ashutosh',
    value: 4,
    email:'cs17b007@iittp.ac.in',
    title: 'Ashutosh Rajput',
    desc: '↠ Civil Services',
    links:'' 
  },
  {
    pub: 'no',
    key: 'nakshatra',
    value: 4,
    email:'cs17b020@iittp.ac.in',
    title: 'Nakshatra Gupta',
    desc: '',
    links:'' 
  },
  {
    pub: 'no',
    key: 'deep',
    value: 4,
    email:'cs17b011@iittp.ac.in',
    title: 'Deep Ghadiyali',
    desc: '↠ Software Engineer',
    links:'' 
  },
  {
    pub: 'no',
    key: 'abhishek',
    value: 4,
    email:'cs17b002@iittp.ac.in',
    title: 'Abhishek Kumar',
    desc: '',
    links:'' 
  },
  {
    pub: 'no',
    key: 'tejasva',
    value: 4,
    email:'cs17b027@iittp.ac.in',
    title: 'Tejasva Motsara',
    desc: '',
    links:'' 
  },
  {
    key: 'vartika',
    value: 3,
    email:'cs18m016@iittp.ac.in',
    title: 'Vartika Agrahari',
    desc: '↠ ML Engineer at Factset Systems Ltd, Hyderabad', 
    links:''
  },
  {
    key: 'vaishali',
    value: 4,
    email:'cs16b015@iittp.ac.in',
    title: 'Vaishali Kamal Khanve', 
    desc: '↠ Samsung R&D Institute Noida', 
    links:''  
  },
  {
    key: 'nikhil',
    value: 4,
    email:'tee15b014@iittp.ac.in',
    title: 'Nikhil Sharma', 
    desc: '↠  Senior Software Engineer at Envestnet Yodlee', 
    links:''  
  },
  {
    key: 'vishal',
    value: 4,
    email:'cs16b033@iittp.ac.in',
    title: 'Vishal Mishra',
    desc: '', 
    links:''   
  },
  {
    key: 'shubham',
    value: 4,
    email:'cs16b026@iittp.ac.in',
    title: 'Sangle Shubham Rajendra',
    desc: '↠ Platform Security Engineer, Versa-Networks', 
    links:''  
     
  },
  {
    key: 'saran',
    value: 4,
    email:'cs16b013@iittp.ac.in',
    title: 'K Saran Teja Reddy',
    desc: '↠ Software Engineer', 
    links:''
       
  },
  {
    key: 'jskreddy',
    value: 4,
    email:'cs16b012@iittp.ac.in',
    title:'Jakku Sai Krupa Reddy',
    desc:'',
    llinks:''
  },
  {
    key: 'sandeep',
    value: 4,
    email:'cs16b017@iittp.ac.in',
    title: 'Sandeep Muvva',
    desc: '↠ IT Software Engineer at UBS', 
    links:'' 
      
  },
  {
    pub:'yes',
    key: 'mahendran',
    value: 3,
    email:'cs19m008@iittp.ac.in',
    title: 'Mahendran N',
    desc: 'Energy consumption, Deep Learning',
    links:`
    LinkedIn [https://www.linkedin.com/in/mahendran-narayanan]
    Google Scholar [https://scholar.google.com/citations?user=c8subicAAAAJ&hl=en]
    Github [https://github.com/mahendran-narayanan]
    Twitter [https://twitter.com/mahendran_kct]
    ORCiD [https://orcid.org/0000-0002-5653-7187]
    ` 
  },
  {
    pub:'yes',
    key: 'sameed',
    value: 4,
    email:'cs18b021@iittp.ac.in',
    title: 'Mir Sameed Ali',
    desc: 'Data Scientist at Razor Group',
    links:`
    LinkedIn [https://www.linkedin.com/in/mir-sameed-ali-329a64175/?originalSubdomain=in]
    ` 
  },
  {
    pub:'yes',
    key: 'n_manjunath',
    value: 4,
    email:'cs18b041@iittp.ac.in',
    title: 'Nikhil Manjunath',
    desc: 'Software Engineering',
    links: `` 
  },
  {
    pub:'yes',
    key: 'prantik',
    value: 3,
    email:'cs20m010@iittp.ac.in',
    title: 'Prantik Parashar Sarmah',
    desc: 'Code Summarization, Software Engineering',
    links:`
    LinkedIn [https://www.linkedin.com/in/prantik-sarmah-31185a117/]
    Github [https://github.com/ros-implon]
    ` 
  },
  {
    pub:'no',
    key: 'shruti',
    value: 4,
    email:'cs18b043@iittp.ac.in',
    title: 'Shruti Priya',
    desc: 'Software Engineering',
    links:`
    LinkedIn [https://www.linkedin.com/in/shruti-priya-56b630175]
    Github [https://github.com/shruti-shrz]
    ` 
  },
  {
    pub:'no',
    key: 'shubhankar',
    value: 4,
    email:'cs18b034@iittp.ac.in',
    title: 'Shubhankar Bhadra',
    desc: 'Empirical Study, Human Computer Interaction',
    links:`
    LinkedIn [https://www.linkedin.com/in/shobhi1310]
    Github [https://github.com/shobhi1310]
    ` 
  },
  {
    pub: 'no',
    key: 'shriram',
    value: 2,
    email:'cs20s503@iittp.ac.in',
    title: 'Shriram Shridhar Shanbhag',
    desc: 'Software Engineering',
    links:`
    LinkedIn [https://www.linkedin.com/in/shriram-shanbhag-9a8138103/]
    Github [https://github.com/tritims]
    ` 
  },
  {
    pub:'no',
    key: 'noble',
    value: 4,
    email:'ch19b023@iittp.ac.in',
    title: 'Noble Saji Mathews',
    desc: 'Code Analysis, Software Engineering',
    links:`
    Website [https://noblesm.com]
    LinkedIn [https://www.linkedin.com/in/noblesmathews]
    Google Scholar [https://scholar.google.com/citations?user=niVr6tgAAAAJ&hl=en]
    ORCiD [https://orcid.org/0000-0003-2266-8848]
    Research Gate [https://www.researchgate.net/profile/Noble_Mathews]
    Github [https://github.com/NobleMathews]
    `
  },
  {
    pub:'no',
    key: 'debeshee',
    value: 4,
    email:'cs19b012@iittp.ac.in',
    title: 'Debeshee Das',
    desc: 'Software Engineering, ML, AI for SE',
    links:`
    LinkedIn [https://www.linkedin.com/in/debeshee-das]
    Github [https://github.com/debesheedas]
    `
  },
].sort((a,b) => a.value-b.value);
export const collaborators = [
  {
    pub:'no',
    key: 'mei',
    value: 5,
    email:'mei.nagappan at uwaterloo dot ca',
    title: 'Meiyappan Nagappan',
    desc: 'Software Engineering',
    links:`
    Website [https://cs.uwaterloo.ca/~m2nagapp/]` 
  },
  {
    pub:'no',
    key: 'nuthan',
    value: 5,
    email:'nm6061@rit.edu',
    title: 'Nuthan Munaiah',
    desc: 'Software Engineering',
    links:`
    Website [https://nuthanmunaiah.github.io/]` 
  },
  {
    pub:'no',
    key: 'marimuthu',
    value: 5,
    email:'cs15fv08.muthu@nitk.edu.in',
    title: 'Marimuthu Chinnakali',
    desc: 'Software Engineering',
    links:`
    Google Scholar [https://scholar.google.co.in/citations?user=O4AxcogAAAAJ&hl=en]` 
  },
  {
    pub:'no',
    key: 'chandrasekaran',
    value: 5,
    email:'kchnitk@ieee.org',
    title: 'Chandrasekaran K',
    desc: 'Software Engineering',
    links:`
    Website [https://cse.nitk.ac.in/faculty/chandrasekaran-k]` 
  },
  {
    pub:'no',
    key: 'vibhu',
    value: 5,
    email:'vibhu.sharma@accenture.com',
    title: 'Vibhu Saujanya Sharma',
    desc: 'Software Engineering',
    links:`
    Linkedin [https://www.linkedin.com/in/sharmavibhu/?originalSubdomain=in]` 
  },
  {
    pub:'no',
    key: 'vikrant',
    value: 5,
    email:'vikrant.kaulgud@accenture.com',
    title: 'Vikrant Kaulgud',
    desc: 'Software Engineering',
    links:`
    Linkedin [https://www.linkedin.com/in/vikrantkaulgud/?originalSubdomain=in]` 
  },

]

export const sponsors = [
  {
    project:"To explore ways to facilitate communication, collaboration and computing skills for undergrads from rural India",
    duration:"Oct 2023 to Oct 2024",
    src:"GoogleResearch.png",
    redirect:"/collaborations",
    title:"Google Research",
    link:"https://research.google/",
  },
  {
    project:"AI Mocktails: Finding Jewels in the Jungle of Source Code Representations and Models for AI-Driven Software Engineering Tasks",
    duration:"Sept 2023 to Sept 2024",
    src:"MicrosoftResearch.png",
    redirect:"/collaborations",
    title:"Microsoft Research",
    link:"https://www.microsoft.com/en-us/research/",
  },
  {
    project:"AI-Driven Bug Classification and Detection in Onboard Satellite Software Systems",
    duration:"Aug 2023 to Aug 2025",
    src:"ISRO.png",
    redirect:"/collaborations",
    title:"Indian Space Research Organization(ISRO)",
    link:"https://www.isro.gov.in/",
  },
  {
    project:"Green AI Frameworks - Comparing Energy Consumption of Deep Learning Frameworks",
    duration:"Aug 2023 to Aug 2024",
    src:"accenturelabs.png",
    redirect:"/collaborations",
    title:"Accenture Labs",
    link:"https://labs.accenture.com/",
  },
  {
    project:"AI Assisted Techniques to Extract Business Rules from Legacy Code Base",
    duration:"Aug 2023 to Aug 2024",
    src:"IBMIRL.jpg",
    redirect:"/collaborations",
    title:"IBM India Research Lab",
    link:"https://research.ibm.com/labs/india/",
  },
  {
    project:"Academic",
    duration:"June 2022 - Present",
    src:"waterloo.jpg",
    redirect:"/collaborations",
    title:"Polytechnique Montréal",
    link:"https://www.polymtl.ca/expertises/en/khomh-foutse",
    collaborator:"Foutse Khomh",
  },
  {
    project:"A Virtual AR/VR Museum for Science and Technology Literacy",
    duration:"Apr 2022 to Apr 2024",
    src:"dst.png",
    redirect:"/collaborations",
    title:"Department of Science and Technology, India",
    link:"https://dst.gov.in/",
  },
  {
    project:"An Approach for Generation of Domain Knowledge Graphs from Source Code",
    duration:"Jan 2022 to Dec 2022",
    src:"bosch.png",
    redirect:"/collaborations",
    title:"Bosch",
    link:"https://www.bosch.com/research/",
  },
  {
    project:"Multi-View Graph Representation Learning for Code",
    duration:"Jan 2022 to Jan 2023",
    src:"IBMIRL.jpg",
    redirect:"/collaborations",
    title:"IBM India Research Lab",
    link:"https://research.ibm.com/labs/india/",
  },
  {
    project:"Towards Comprehending COBOL Programs using Knowledge Graphs",
    duration:"Oct 2021 to Oct 2022",
    src:"exafluence.png",
    redirect:"/collaborations",
    title:"Exafluence",
    link:"https://exafluence.com/",
  },
  {
    project:"Online Facilitation of Debugging Skills through Game Based Learning",
    duration:"July 2021 to December 2021",
      src:"COL.jpg",
      redirect:"/collaborations",
      title:"Commonwealth Educational Media Centre for Asia (CEMCA)",
      link:"https://www.cemca.org/",
  },
  {
    project:"Discovering Energy-Hungry Patterns in Machine Learning Driven Software Systems",
    duration:"May 2021 to May 2022",
      src:"accenturelabs.png",
      redirect:"/collaborations",
      title:"Accenture Labs",
      link:"https://labs.accenture.com/",
  },
  {
    project:"An Approach for Incremental Generation of Knowledge Graphs from Source Code and Requirements",
    duration:"Nov 2020 to Nov 2021",
    src:"bosch.png",
    redirect:"/collaborations",
    title:"Bosch",
    link:"https://www.bosch.com/research/",
  },
  {
    project:"SurviveCovid-19++ - A Game for Improving Awareness of Social Distancing and Health Measures for Covid-19 Pandemic",
    duration:"May 2020 to April 2021",
      src:"rlf.jpg",
      redirect:"/collaborations",
      title:"Richard Lounsbery Foundation",
      link:"https://www.rlounsbery.org/",
  },
  {
    project:"Software Reuse and Quality Analysis of an Online Coding Platform",
    duration:"April 2019 to April 2022",
    src:"codechef.png",
    redirect:"/collaborations",
    title:"CodeChef",
    link:"https://www.codechef.com/",
  },
  {
    project:"A Novel Approach for Bug Localization",
    duration:"Nov 2019 to Nov 2020",
    src:"bosch.png",
    redirect:"/collaborations",
    title:"Bosch",
    link:"https://www.bosch.com/research/",
  },
  {
    project:"Academic",
    duration:"May 2019 - Present",
    src:"waterloo.jpg",
    redirect:"/collaborations",
    title:"University of Waterloo",
    link:"https://cs.uwaterloo.ca/~m2nagapp/index.html",
    collaborator:"Mei Nagappan",
  },
  // {
  // project:"AiR: Pollution Visualizer expansion towards climate literacy",
  // duration:"May 2021 to May 2022",
  //   src:"earthwatch.png",
  //   redirect:"/collaborations",
  //   title:"Earthwatch Foundation",
  //   link:"https://earthwatch.org/",
  // },
]

export const authors = members.concat(alumini,collaborators);

export const categories = ['SE','ET','HCI','C&S'];
